import { render } from "./CompaniesView.vue?vue&type=template&id=911833ac"
import script from "./CompaniesView.vue?vue&type=script&lang=js"
export * from "./CompaniesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__